'use strict';
import * as $j_app$002eapi$002e$002dPharmacy$002dApp$002dUpdate from "./app.api.-Pharmacy-App-Update.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention(ids) {
  this.Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention__f_ids = null;
  this.Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention__f_ids = ids;
}
export { $c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention as $c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention };
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention.prototype = new $j_app$002eapi$002e$002dPharmacy$002dApp$002dUpdate.$h_Lapp_api_PharmacyAppUpdate();
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention.prototype.constructor = $c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention;
/** @constructor */
function $h_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention() {
}
export { $h_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention as $h_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention };
$h_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention.prototype = $c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention.prototype;
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 545893709, true);
});
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention)) {
    var x = this.Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention__f_ids;
    var y = x$0.Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention__f_ids;
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().equals__O__O__Z(x, y);
  } else {
    return false;
  }
});
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention.prototype.productPrefix__T = (function() {
  return "AcceptedDrugRequestNeedsAttention";
});
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention__f_ids;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "ids";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention.prototype.ordinal__I = (function() {
  return 6;
});
function $isArrayOf_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention)));
}
export { $isArrayOf_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention as $isArrayOf_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention };
var $d_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention, "app.api.PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention", ({
  Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention: 1,
  Lapp_api_PharmacyAppUpdate: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  Lapp_api_PharmacyAppUpdate$InitialState: 1
}));
export { $d_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention as $d_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention };
//# sourceMappingURL=app.api.-Pharmacy-App-Update$-Accepted-Drug-Request-Needs-Attention.js.map
